export const convertToQueryString = items =>
  items
    .map(item => {
      if (item.type === 'conditional-text') {
        const fieldCondition = Object.values(item.conditions).find(condition =>
          condition(item.value)
        );
        item.field = fieldCondition(item.value);
        item.value = encodeURIComponent(item.value);
      }

      return `${item.field}=${item.value}`;
    })
    .join('&');

export const getFormattedFilters = (filters, values) => {
  const filtersWithCustomModules = filters.flatMap(filter => {
    if (filter.type === 'custom-keyword') {
      return Object.values(filter.field);
    }
    return filter;
  });

  return filtersWithCustomModules.reduce((acc, current) => {
    const fieldValue = values[current.field];

    if (!fieldValue || fieldValue?.value === 'all') return acc;

    return [
      ...acc,
      {
        field: current.field,
        label: current.label,
        conditions: current.conditions,
        type: current.type,
        chipValue: values[current.field]?.label || values[current.field],
        value: values[current.field]?.value || values[current.field],
      },
    ];
  }, []);
};
